import { Link, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useActivity, useEventStream, useMe, useSystem } from '../hooks/queries';

export function Shell() {
  const me = useMe();
  const nav = useNavigate();
  const system = useSystem();
  const activity = useActivity();
  useEventStream(!!me.data);
  useEffect(() => {
    const h = () => void nav({ to: '/login' });
    window.addEventListener('lore:unauthenticated', h);
    return () => window.removeEventListener('lore:unauthenticated', h);
  }, [nav]);
  useEffect(() => {
    if (me.isError) void nav({ to: '/login' });
  }, [me.isError, nav]);
  if (me.isLoading) return <div className="empty">…</div>;
  if (!me.data) return null;
  const ks = system.data?.kill_switch.engaged;
  const stale = system.data?.worker.stale;
  const needs = (activity.data?.held_intents.length ?? 0) + (activity.data?.candidate_assets.length ?? 0);
  return (
    <div className="shell">
      <div className={`strip${ks ? ' kill' : ''}`}>
        <Link to="/system" style={{ color: 'inherit' }}>
          {ks ? '■ KILL SWITCH ENGAGED' : stale ? '● worker not seen recently' : `● ${system.data ? `${system.data.env} · ai ${system.data.modes.ai} · data ${system.data.modes.market}` : 'connecting'}`}
        </Link>
        <span className="faint">{system.data?.app_version}</span>
      </div>
      <main className="shell-main">
        <Outlet />
      </main>
      <nav className="nav">
        <Link to="/" activeOptions={{ exact: true }} activeProps={{ className: 'active' }}>Narratives</Link>
        <Link to="/activity" activeProps={{ className: 'active' }}>Activity{needs > 0 && <span className="badge">{needs}</span>}</Link>
        <Link to="/system" activeProps={{ className: 'active' }}>System</Link>
      </nav>
    </div>
  );
}
